<template>
  <figure class="article-cover-img">
    <!-- Cover image -->
    <img width="1200" height="628" :alt="alt" :loading="loading" :src="src" :title="alt" />
    <!-- Cover image aspect ratio placeholder -->
    <span class="article-cover-img__placeholder" />
  </figure>
</template>

<script>
export default {
  props: {
    /**
     * Cover image alternative text
     */
    alt: {
      required: true,
      type: String,
    },

    /**
     * Cover image loading strategy
     */
    loading: {
      default: false,
      type: [Boolean, String],
    },

    /**
     * Cover image source
     */
    src: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-cover-img {
  @apply relative w-full overflow-hidden;

  & img {
    @apply absolute w-full h-full z-1;
    @apply object-cover object-center;
  }
  & .article-cover-img__placeholder {
    @apply block w-full pointer-events-none z-0;
    padding-top: 52.33333%; /* 628px / 1200px */
  }
}
</style>
